import { IOrganizerCard } from '../interfaces/organizer-card';
import { OrganizerListItem } from '../interfaces/organizer-list-item';
import { formatSubscriptionExpiry } from '../utils/format-subscription-expiry';

/**
 * Строка списка организаций → пропсы карточки. Маппер жил здесь и раньше, но
 * принимал `OrganizerDetails` (карточку одной организации), которую список
 * никогда не грузит, поэтому страница делала то же преобразование у себя.
 */
export class OrganizerToCardDataMapper {
  public decode(payload: OrganizerListItem): IOrganizerCard {
    return {
      name: payload.name,
      sportType: payload.sportType,
      logo: payload.logoUrl,
      phone: payload.phone,
      createAt: payload.createdAt,
      subscriptionExpiry: formatSubscriptionExpiry(payload.subscriptionSummary),
      user: payload.adminUser,
      address: payload.address,
    };
  }
}

export const organizerToCardDataMapper = new OrganizerToCardDataMapper();
